import { ClaimDetailLossReport } from '@/components/Domains/Claims/Views/ClaimDetailLossReport'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/claims/$claimNumber/_layout/loss-report')({
  component: ClaimDetailLossReport,
})
